(function () {
    'use strict';

    angular.module('app.settings', [
        // Angular modules
        'ngRoute'

        // Custom modules

        // 3rd Party Modules

    ]);
})();